/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import SMSMagicSvg from "../../assets/svg/SMS-Magic.svg";
import SalesforceImg from "../../assets/svg/Salesforce_logo_img.svg.png";
import Hand from "../../assets/svg/Hand.svg";
import {
  ABORT_API,
  // eslint-disable-next-line no-unused-vars
  CANCEL_PAGE_TIMEOUT,
  SF_INSTALL_API,
  SF_PACKAGE_INFO_API,
  WORKSPACE_REDIRECT_TIMEOUT,
} from "../../constants/common";
import NoAccountFound from "./NoAccountFound";
import LatestVersion from "./LatestVersion";
import UpgradeCancelled from "./UpgradeCancelled";
import PermissionDenied from "./permission-denied";
import OrgUpgradeNotEligible from "./OrgUpgradeNotEligible";
import ShimmerEffect from "./ShimmerEffect";
import DataCenterUpdate from "./DataCenterUpdate";
import InfoIcon from "@mui/icons-material/Info";
import { IconButton } from "@mui/material";
import SessionExpired from "./SessionExpired";
import ConfirmationDialog from "./ConfirmationDialog";


const UpgradePackage = ({ state }) => {
  const [countdown, setCountdown] = useState(null);
  const [cancelShow, setCancelShow] = useState(false);
  const [upgradePackageInfo, setUpgradePackageInfo] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [isCancelButtonClicked, setIsButtonCancelClicked] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [countdownCancel, setCountdownCancel] = useState(null);
  const [noAccountFound, setNoAccountFound] = useState(false);
  const [noAccountFoundCode,setNoAccountFoundCode]=useState('');
  const [packageNotInstalled, setPackageNotInstalled] = useState(false);
  const [latestVersionInstalled, setLatestVersionInstalled] = useState(false);
  const [orgUpgradeNotEligible, setOrgUpgradeNotEligible] = useState(false);
  const [permissionDenied, setPermissionDenied] = useState(false);
  const [loadingShimmer, setLoadingShimmer] = useState(true);
  const [isSessionExpired,setIsSessionExpired]=useState(false);
  const [gotPkgInfoResponse,setGotPkgInfoResponse]=useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isUpgradeAvailable,setIsUpgradeAvailable]=useState(false);
  const [isUpgradeLoading, setIsUpgradeLoading] = useState(false);
  const [isContinueLoading, setIsContinueLoading] = useState(false);
  const [pkgVersionCond,setPkgVersionCond]=useState(false);
  // let state = {
  //   dataCenter: "US",
  //   addons: {
  //     type: "upgrade",
  //     package_installed: false,
  //     account_exists: true,
  //     latest_version: "1.73",
  //     upgrade_available: true,
  //     package_version: "1.72.22",
  //   },
  // };

    // eslint-disable-next-line no-unused-vars
  const [country, setCountry] = useState(
    state?.dataCenter == "US"      // eslint-disable-line eqeqeq
      ? "US"
      : state?.dataCenter == "EU"    // eslint-disable-line eqeqeq
      ? "Europe"
      : "Australia"
  );
   // eslint-disable-next-line no-unused-vars
  const [isDataCenterChanged,setIsDataCenterChanged]=useState(state?.skip_data_center_check);

  const intervalIdRef = useRef(null);
  let action = state?.action;
  let intervalCancel;

/* eslint-disable eqeqeq */
useEffect(() => {
  if(state?.skip_data_center_check!=true ||(state?.skip_data_center_check==true && state?.addons?.package_installed==false) || 
    (state?.skip_data_center_check==true && state?.addons?.package_version < "1.68")){
      if(state?.addons?.package_version <"1.68"){
        console.log('in pkg version condition 1.68');
        setPkgVersionCond(true);
      }
    callPackageInfoAPI();
  }else{
    setLoadingShimmer(false);
  }
  return () => {
    clearInterval(intervalIdRef.current);
    clearInterval(intervalCancel);
  };
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);
/* eslint-enable eqeqeq */

  const callPackageInfoAPI = async (type="") => {
    let queryStr = state?.queryStr;
    let baseUrl = `${window.location.protocol}//${window.location.host}`;
    let url = `${baseUrl}${SF_PACKAGE_INFO_API}?${queryStr}`;
    //comment
    try {
      let response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("response sf package info api: ", response);


      let packageInfoResponse = await response.json();
      setLoadingShimmer(false);
      // comment
      // let packageInfoResponse={
      //   account_id: "122333",
      //   package_installed:false,
      //   upgrade_available: false,
      //  latest_version: "1.73.33"
      
      // }
      setGotPkgInfoResponse(true);
      setUpgradePackageInfo(packageInfoResponse);
      // const response = {
      //   "status": 200,
      // }
      // const packageInfoResponse = {
      //   account_id: "122333",
      //   access_token: "token",
      //   refresh_token: "refresh_token",
      //   package_installed: "",
      //   upgrade_available: false,
      //   latest_version: "1.73.33"
      // }
     

      if (response.status === 200) {

        if(type=="continueWorkspace"){   // eslint-disable-line eqeqeq
          console.log('redirecting to workspcase');
          localStorage.setItem(
            "stories_delight",
            packageInfoResponse.access_token
          );
          localStorage.setItem("hideBullhorn", "false");
          window.location.replace(
            `${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`
          );
          return
        }
        if(type==="upgrade"){
          localStorage.setItem(
            "stories_delight",
            packageInfoResponse.access_token
          );
          localStorage.setItem("hideBullhorn", "false");
          //call upgrade api
          callSFInstall(packageInfoResponse?.account_id,packageInfoResponse?.upgrade_available);
        }

        console.log('packageInfoResponse',packageInfoResponse);
        if(packageInfoResponse?.data_center){
          console.log('in data center',packageInfoResponse);
          let dataCenter = packageInfoResponse?.data_center?.toUpperCase();
          let SALESFORCE_CONFIG;
        let rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG;
        // eslint-disable-next-line eqeqeq
        if (dataCenter == "US") {
            console.log("In US Data Center");
            rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG_US;
            // eslint-disable-next-line eqeqeq
        } else if (dataCenter == "EU") {
            console.log("In EU Data Center");
            rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG_EU;
            // eslint-disable-next-line eqeqeq
        } else if (dataCenter == "AUS") {
            console.log("In AUS Data Center");
            rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG_AUS;
        }
          // eslint-disable-next-line eqeqeq
        if (dataCenter == "INTG") {
          console.log("In INTEGRATION Data Center");
          rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG_INTG;
          // eslint-disable-next-line eqeqeq
      } else if (dataCenter == "QA") {
          console.log("In QA Data Center");
          rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG_QA;
          // eslint-disable-next-line eqeqeq
      } else if (dataCenter == "STAGING") {
          console.log("In STAGING Data Center");
          rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG_STAG;
      }
        try {
          // eslint-disable-next-line no-useless-escape
          const decodedConfig = rawConfig.replace(/\\\"/g, '"').replace(/\\\\/g, '\\');
          SALESFORCE_CONFIG = JSON.parse(decodedConfig);
        } catch (error) {
            alert('Something went wrong')
            console.error("Error parsing SALESFORCE_CONFIG:", error);
            window.history.back();
            return;
        }
        const prod = SALESFORCE_CONFIG.salesforceProd;
        // const sandbox = SALESFORCE_CONFIG.salesforceSandbox;
        let socialProvider=state?.org_type;
        let code=packageInfoResponse?.code;
        let action=state?.action;
        let account_exists=packageInfoResponse?.account_exists;
        let package_installed=packageInfoResponse?.package_installed;
        let latest_version=packageInfoResponse?.latest_version;
        let upgrade_available=packageInfoResponse?.upgrade_available;
        let package_version=packageInfoResponse?.package_version;
        
        

        const new_state = `org_type=${socialProvider}&source=app_exchange&dataCenter=${dataCenter}&action=${action}&account_exists=${account_exists}&package_installed=${package_installed}&skip_data_center_check=true&upgrade_available=${upgrade_available}&latest_version=${latest_version}&package_version=${package_version}`;
        console.log("state in sso url is-------->", state);

        // Preserve the code_verifier from the current queryStr so the destination
        // region's backend can complete the token exchange with Salesforce.
        const currentParams = new URLSearchParams(queryStr);
        const existingVerifier = currentParams.get('code_verifier');
        const verifierPart = existingVerifier ? `&code_verifier=${encodeURIComponent(existingVerifier)}` : '';

        let url=`${prod.params.redirect_uri}/?code=${code}${verifierPart}&state=${encodeURIComponent(new_state)}`

        window.parent.location.href = url;

        }
        else{
        localStorage.setItem(
          "stories_delight",
          packageInfoResponse.access_token
        );
        localStorage.setItem("hideBullhorn", "false");
        setCancelShow(true);
        setCountdown(WORKSPACE_REDIRECT_TIMEOUT);
        handlePackageUpgrade(packageInfoResponse);
      }
      } else if (response.status === 400) {
        console.log('saving code',packageInfoResponse?.code);
        setNoAccountFoundCode(packageInfoResponse?.code);
        setNoAccountFound(true);
      }else if (response.status === 500) {
        setIsSessionExpired(true);
      }  
      else {
        alert("SOMETHING WENT WRONG");
        window.history.back();
      }
    } catch (error) {
      console.log("error in fetch api call: ", error);
      if (error.response?.status === 500) {
        setIsSessionExpired(true);
        return 
      }
      alert("SOMETHING WENT WRONG");
      window.history.back();
    }
  };

  const handlePackageUpgrade = (packageInfo) => {
    const { upgrade_available, package_installed, account_id } = packageInfo;
    if (!upgrade_available && !package_installed) {
      setPackageNotInstalled(true);
    }
    
    if (upgrade_available && isUpgradeAvailable) {
      console.log('Inside upgrade available condition',upgrade_available);
      callSFInstall(account_id, upgrade_available);
    }

    if (!upgrade_available && package_installed && package_installed >= "1.68") {
      setLatestVersionInstalled(true);
      intervalIdRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(intervalIdRef.current);
            window.location.replace(
              `${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`
            );
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    if (!upgrade_available && package_installed && package_installed < "1.68") {
      setOrgUpgradeNotEligible(true);
      intervalIdRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(intervalIdRef.current);
            window.location.replace(
              `${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`
            );
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    if ((!upgrade_available && !package_installed)) {
      intervalIdRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(intervalIdRef.current);
            callSFInstall(account_id, upgrade_available);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  };

  const callSFInstall = async (account_id, upgrade_available) => {
    let baseUrl = `${window.location.protocol}//${window.location.host}`;
    let url = `${baseUrl}${SF_INSTALL_API}`;
    let is_upgrade = upgrade_available ? true : false;
    let payload = { account_id, is_upgrade };

    try {
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (res.status === 200) {
        window.location.replace(
          `${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`
        );
      } else if (res.status === 403) {
        setPermissionDenied(true);
      }else if(res.status === 500){
        setIsSessionExpired(true);
      }
      else {
        alert("SOMETHING WENT WRONG");
        window.history.back();
      }
    } catch (error) {
      console.error("Error in callSFInstall: ", error);
      if (error.response?.status === 500) {
        setIsSessionExpired(true);
        return 
      }
      alert("SOEMTHING WENT WRONG");
      window.history.back();
    }
  };

  const handleCancel = async (action) => {

    if (!showConfirmation) {
      setShowConfirmation(true);
      // Pause the timer by clearing the interval
      clearInterval(intervalIdRef.current);
      return;
    }

    setShowConfirmation(false);
    // setIsButtonCancelClicked(true);
    let baseUrl = `${window.location.protocol}//${window.location.host}`;
    let url = `${baseUrl}${ABORT_API}`;
    if (packageNotInstalled) {
      action = "install";
    }
    let payload = { action };
    try {
      let res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      if (res.status === 200) {
        // clearInterval(intervalIdRef.current);
        // setCountdownCancel(CANCEL_PAGE_TIMEOUT);
        // intervalCancel = setInterval(() => {
        //   setCountdownCancel((prev) => {
        //     if (prev === 1) {
        //       clearInterval(intervalCancel);
        //       window.location.replace(
        //         `${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`
        //       );
        //       return 0;
        //     }
        //     return prev - 1;
        //   });
        // }, 1000);
        window.location.replace(
          `${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`
        );
      } else {
        alert("SOMETHING WENT WRONG");
        window.history.back();
      }
    } catch (error) {
      console.error("Error in handleCancel: ", error);
      alert("SOMETHING WENT WRONG");
      window.history.back();
    }
  };

  const handleUpdate = async (type) => {
    console.log("in handleUpdate", type);
    if (type == "continue") { // eslint-disable-line eqeqeq
      console.log("calling package info api");
      setIsContinueLoading(true);
      localStorage.setItem(
        "stories_delight",
        upgradePackageInfo.access_token
      );
      localStorage.setItem("hideBullhorn", "false");
      window.location.replace(
        `${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`
      );
    } else if (type === "upgrade") {
      setIsUpgradeAvailable(true);
      setIsUpgradeLoading(true);
      await callSFInstall(upgradePackageInfo.account_id, upgradePackageInfo.upgrade_available);
    }
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
    intervalIdRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(intervalIdRef.current);
          callSFInstall(upgradePackageInfo.account_id, upgradePackageInfo.upgrade_available);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };
  

  return (
    <>
      {loadingShimmer ? (
        <ShimmerEffect />
      ) : isSessionExpired? <SessionExpired/>:
      
      // eslint-disable-next-line eqeqeq
      (isDataCenterChanged && state?.addons?.package_installed && pkgVersionCond==false) ? (
        <DataCenterUpdate state={state} callPackageInfoAPI={callPackageInfoAPI} isContinueLoading={isContinueLoading} isUpgradeLoading={isUpgradeLoading}/>
      ):
      
      noAccountFound ? (
        <NoAccountFound state={state} noAccountFoundCode={noAccountFoundCode} />
      ) : latestVersionInstalled ? (
        <LatestVersion
          upgradePackageInfo={upgradePackageInfo}
          countdown={countdown}
        />
      ) : orgUpgradeNotEligible ? (
        <OrgUpgradeNotEligible
          upgradePackageInfo={upgradePackageInfo}
          countdown={countdown}
        />
      ) : isCancelButtonClicked ? (
        <UpgradeCancelled
          countdownCancel={countdownCancel}
          packageNotInstalled={packageNotInstalled}
        />
      ) : permissionDenied ? (
        <PermissionDenied permissionDenied={permissionDenied} />
      ) : (
        <div className="installation-container">
          {gotPkgInfoResponse &&
          <header style={{ padding: "20px" }} className="header">
            <div className="flex items-center gap-2">
              <a href="/salesforce/setup" className="magic-logo">
                <img
                  src="https://sm-icon-assets.s3.us-east-1.amazonaws.com/sms-magic-logo.svg"
                  alt="logo"
                  style={{ height: "24px", width: "143.3px" }}
                ></img>
              </a>
            </div>
          </header>
          }
          <main className="main-content">
          {!upgradePackageInfo?.data_center && gotPkgInfoResponse &&
            <div className="icon-container">
              <img
                src={SMSMagicSvg}
                alt="SMS-Magic Icon"
                className="icon"
                style={{ width: "180px", height: "131.5px" }}
              />
              <div className="dotted-line" />
              <div>
                <img src={Hand} alt={"hand"} className={"hand"} />
              </div>
              <div className="dotted-line" />
              <div className="salesforce-logo-container">
                <img
                  src={SalesforceImg}
                  alt="Salesforce Logo"
                  className="salesforce-logo"
                  style={{ width: "180px", height: "126.75px" }}
                />
              </div>
            </div>
          }
            {packageNotInstalled && state?.skip_data_center_check && state?.addons?.package_installed==false &&  // eslint-disable-line
                  <div className="info-box-cancel" style={{ marginBottom: "10px" }}>
                  <IconButton style={{ padding: "0px" }}>
                    <InfoIcon style={{ padding: "0px", color: "#AEB0B1" }} />
                  </IconButton>
        
                  <span className="info-text">
                    You have an account on the {country} Data Center
                  </span>
                </div>

            }

            {packageNotInstalled ? (
              <div className="installation-text-hero">
                <h1 className="title">
                  No packages found for you to upgrade. <br /> Installing the
                  latest ones now
                </h1>
                <p className="subtitle-magic">
                  Your SMS Magic package is being installed and configured now.
                </p>
              </div>
            ) : (
              <>
              {upgradePackageInfo?.package_installed && upgradePackageInfo?.latest_version &&
                !upgradePackageInfo?.data_center &&
                <>
              <div className="installation-text-hero">
                <h1 className="title">
                  Upgrade Your SMS Magic Account from <br />
                  {upgradePackageInfo?.package_installed} to the Latest Version{" "}
                  {upgradePackageInfo?.latest_version}
                </h1>
                <p className="subtitle-magic">
                  Upgrade to latest version for enhanced support and improved efficiency. <br />
                  View the,{" "}
                  <a
                    href={process.env.REACT_APP_RELEASE_NOTES}
                    rel="noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    release notes
                  </a>{" "}
                  to compare updates.
                </p>
              </div>
              <button
                className="install-packages"
                style={{
                  fontSize: "14px",
                  color: "white",
                  padding: "0px 15px",
                  width: "250px",
                  display: "flex",
                  alignItems: "center",
                  gap: "0px",
                  justifyContent: "space-evenly"
                }}
                onClick={() => handleUpdate("upgrade")}
              >
                Upgrade to latest version
                {isUpgradeLoading && 
                    <div className="" style={{marginTop: "2px"}}>
                        <div className="spinner-border" role="status" style={{width: "20px", height: "20px"}}/>
                    </div>}
              </button>
              <span
                onClick={() => handleUpdate("continue")}
                className={"cancel-link-text"}
                style={{ marginTop: "12px", textDecoration: "none", display: "flex", alignItems: "center", gap: "8px" }}
              >
                Continue without upgrade
                {isContinueLoading && 
                    <div className="">
                        <div className="spinner-border" role="status" style={{width: "20px", height: "20px"}}/>
                    </div>}
              </span>
              </>
              }
              </>
            )}

            { !upgradePackageInfo?.data_center && gotPkgInfoResponse && packageNotInstalled &&
            <div
              className="cancel-link"
              style={{ marginBottom: "20px", marginTop: "20px" }}
            >
              {/* {packageNotInstalled ? (
                <>Do you want to cancel installation?{" "} </>
              ) : (
                <>Click here if you want to cancel the upgrade. </>
              )} */}
              Do you want to cancel installation?{" "}
              <a
                href="#"
                onClick={() => handleCancel(action)}
                className={
                  cancelShow ? "cancel-link-text" : "cancel-link-text-disabled"
                }
              >
                Cancel
              </a>
            </div>
              }

            {showConfirmation && 
              <ConfirmationDialog 
                onClose={handleCloseConfirmation}
                onConfirm={() => handleCancel(action)}
                type="upgrade"
              />
            }

            {countdown !== null && packageNotInstalled && (
              <div
                className="workspace-redirect"
                style={{ marginBottom: "20px", marginTop: "20px" }}
              >
                Redirecting to workspace in{" "}
                <span className="timer">{countdown} seconds</span>
              </div>
            )}
          </main>
        </div>
      )}
    </>
  );
};

export default UpgradePackage;
